import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { FaqItemWidget } from '../../../core/models';
import { SvgComponent } from '../svg/svg.component';
import { NgClass } from '@angular/common';

@Component({
  selector: 'sc-faq-item-widget',
  imports: [SvgComponent, NgClass],
  animations: [
    trigger('faqItemAnimation', [
      transition(':enter', [
        style({ height: '0px', opacity: 0, overflow: 'hidden' }),
        animate('300ms ease-in-out', style({ height: '*', opacity: 1 })),
      ]),
      transition(':leave', [
        style({ overflow: 'hidden' }),
        animate('300ms ease-in-out', style({ height: '0px', opacity: 0 })),
      ]),
    ]),
  ],
  templateUrl: './faq-item-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqItemWidgetComponent {
  @Input() faqItem: FaqItemWidget;
  isOpen = false;
}
